import { render, staticRenderFns } from "./VACTimer.vue?vue&type=template&id=a4c63400&scoped=true&"
import script from "./VACTimer.vue?vue&type=script&lang=js&"
export * from "./VACTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c63400",
  null
  
)

export default component.exports